import React, { useState } from 'react';

const KovTerm = ({ text, href, highlight, onClick }) => {
  const [hovered, setHovered] = useState(false);
  const onClickHandler = () => {
    onClick?.(href, text);
  };

  if (highlight) {
    return (
      <b
        onMouseOver={() => setHovered(true)}
        onMouseOut={() => setHovered(false)}
        style={{ color: hovered ? '#9B009B' : '#34495e' }}
        className="kov-term theme-content-begrip highlighted"
        dangerouslySetInnerHTML={{ __html: text }}
      ></b>
    );
  }
  return (
    <a
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
      style={{ color: hovered ? '#9B009B' : '#34495e' }}
      className="kov-term theme-content-begrip"
      id={href}
      onClick={onClickHandler}
    >
      <span className="compiled-text" dangerouslySetInnerHTML={{ __html: text }}></span>
      <i className="glyphicon glyphicon-question-sign"></i>
    </a>
  );
};

export default KovTerm;
